import { Form, Field } from 'formik';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Button } from 'primereact/button';
import * as Yup from 'yup';
import { numericValue } from '@utils';

const form =
  ({ role, allCompany, isEditing, loading }) =>
  ({ errors, touched, setFieldValue }) =>
    (
      <Form>
        <div className='m-0 form'>
          {role === 'admin' && !isEditing && (
            <div className='form__elem'>
              <span className='p-float-label'>
                <Field name='company' className={errors.company && touched.company ? 'p-invalid' : ''}>
                  {({ field }) => (
                    <Dropdown
                      value={field.value}
                      options={allCompany ?? []}
                      onChange={(e) => setFieldValue('company', e.value)}
                      optionLabel='name'
                    />
                  )}
                </Field>
                <label htmlFor='company'>Підриємство</label>
              </span>
              {errors.company && touched.company ? (
                <small id='company-help' className='p-error'>
                  {errors.company}
                </small>
              ) : null}
            </div>
          )}
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field name='name' as={InputText} className={errors.name && touched.name ? 'p-invalid' : ''} />
              <label htmlFor='name'>Назва</label>
            </span>
            {errors.name && touched.name ? (
              <small id='name-help' className='p-error'>
                {errors.name}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field
                name='fullName'
                as={InputText}
                className={errors.fullName && touched.fullName ? 'p-invalid' : ''}
              />
              <label htmlFor='fullName'>Повна назва</label>
            </span>
            {errors.fullName && touched.fullName ? (
              <small id='fullName-help' className='p-error'>
                {errors.fullName}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field name='ipn' as={InputText} className={errors.ipn && touched.ipn ? 'p-invalid' : ''} />
              <label htmlFor='ipn'>ІПН/Платник ПДВ</label>
            </span>
            {errors.ipn && touched.ipn ? (
              <small id='ipn-help' className='p-error'>
                {errors.ipn}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field
                name='edrpou'
                as={InputText}
                onChange={(e) => setFieldValue('edrpou', numericValue(e.target.value))}
                useGrouping={false}
                className={errors.edrpou && touched.edrpou ? 'p-invalid' : ''}
              />
              <label htmlFor='edrpou'>Код ЄДРПОУ</label>
            </span>
            {errors.edrpou && touched.edrpou ? (
              <small id='edrpou-help' className='p-error'>
                {errors.edrpou}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field name='address' as={InputText} className={errors.address && touched.address ? 'p-invalid' : ''} />
              <label htmlFor='address'>Адреса</label>
            </span>
            {errors.address && touched.address ? (
              <small id='address-help' className='p-error'>
                {errors.address}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field
                name='contactName'
                as={InputText}
                className={errors.contactName && touched.contactName ? 'p-invalid' : ''}
              />
              <label htmlFor='contactName'>Контактна особа</label>
            </span>
            {errors.contactName && touched.contactName ? (
              <small id='contactName-help' className='p-error'>
                {errors.contactName}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field
                name='phone'
                as={InputMask}
                mask='999-999-99-99'
                className={errors.phone && touched.phone ? 'p-invalid' : ''}
              />
              <label htmlFor='phone'>Номер телефону</label>
            </span>
            {errors.phone && touched.phone ? (
              <small id='phone-help' className='p-error'>
                {errors.phone}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field name='email' as={InputText} className={errors.email && touched.email ? 'p-invalid' : ''} />
              <label htmlFor='email'>Е-mail</label>
            </span>
            {errors.email && touched.email ? (
              <small id='email-help' className='p-error'>
                {errors.email}
              </small>
            ) : null}
          </div>
          <Button
            type='submit'
            loading={loading}
            className='form__button'
            label={isEditing ? 'Зберегти' : 'Створити'}
            icon='pi pi-check'
          />
        </div>
      </Form>
    );
const schema = ({ role, isEditing }) => {
  return Yup.object().shape({
    ...(role === 'admin' && !isEditing
      ? {
          company: Yup.object().required('Виберіть підприємство'),
        }
      : {}),
    name: Yup.string().required('Напишіть назву').min(2, 'Занадто коротка!').max(150, 'Занадто довга!'),
    fullName: Yup.string().min(2, 'Занадто коротка!').max(350, 'Занадто довга!'),
    ipn: Yup.string().min(2, 'Занадто короткий!').max(100, 'Занадто довгий!'),
    edrpou: Yup.string().min(0, 'Занадто коротке!').max(100, 'Занадто довге!'),
    address: Yup.string().min(2, 'Занадто коротка!').max(250, 'Занадто довга!'),
    contactName: Yup.string().min(2, 'Занадто коротке!').max(250, 'Занадто довге!'),
    phone: Yup.string().matches(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/, 'Невірний формат номера телефона'),
    email: Yup.string().email('Невірний формат email').min(2, 'Занадто короткий!').max(250, 'Занадто довгий!'),
  });
};

const initialValues = (data, role, isEditing) => {
  return {
    ...(role === 'admin' && !isEditing
      ? {
          company: data?.company_id ? { _id: data?.company_id, name: data?.company_name } : null,
        }
      : {}),
    name: data?.name ?? '',
    fillName: data?.fillName ?? '',
    ipn: data?.ipn ?? '',
    edrpou: data?.edrpou ?? '',
    address: data?.address ?? '',
    contactName: data?.contactName ?? '',
    phone: data?.phone ?? '',
    email: data?.email ?? '',
  };
};

export default { form, schema, initialValues };
